import * as actionTypes from './actionTypes';
import * as actions from './index';

export const massEditSelected = (clipIds) => {
    return {
        type: actionTypes.MASS_EDIT_SELECTED,
        payload: { clips: clipIds }
    };
};

export const resetMassEditClips = () => {
    return {
        type: actionTypes.RESET_MASS_EDIT_SELECTED
    }
}

export const selectClip = (clip) => {
    return {
        type: actionTypes.SELECT_CLIP,
        payload: { clip: clip }
    };
};

export const resetTickedClips = () => {
    return {
        type: actionTypes.RESET_TICKED_CLIPS
    }
}

export const resetMultiSelected = () => {
    return {
        type: actionTypes.RESET_MULTISELECTED
    }
}

export const clipDragStart = (clipId) => {
    return {
        type: actionTypes.CLIP_DRAG_START,
        payload: { clipId: clipId }
    }
}

export const cutClipStart = (clipId) => {
    return {
        type: actionTypes.CUT_CLIP_START,
        payload: { cutting: true }
    }
}

export const cutClipSuccess = (clipId) => {
    return {
        type: actionTypes.CUT_CLIP_SUCCESS,
        payload: { cuttedCLip: clipId, cutting: false }
    }
}

export const cutClipFail = (clipId) => {
    return {
        type: actionTypes.CUT_CLIP_FAIL,
        payload: { clipId: clipId, cutting: false }
    }
}

export const cutClip = (clip, newtitle, batch, preset, source, add = {}) => {
    return dispatch => {
        window.flow.cutQuick(clip, newtitle, batch, preset, source, add).then(response => {
            console.log(response);
            dispatch(cutClipStart())
            if (response.success) {
                dispatch(cutClipSuccess(clip.id));
            } else {
                dispatch(cutClipFail(response));
            }
        }).catch(response => {
            console.log(response);
            dispatch(cutClipFail(response));
        });
    }
}


export const grabMainThumb = (clipId, frame, width, height) => {

    const params = {
        createthumbmf: 1,
        post_width: width,
        post_height: height,
        autothumbmode: 'replacemainthumb',
        dumprate: 1,
        dumptype: 'numberofframes',
        transcoder: 'ffmpeg',
        findtags: 'sourcefile',
        lframe: frame,
        fframe: frame,
    };

    console.log("GRAB MAIN THUMB");

    return dispatch => {
        dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_START });
        window.flow.newProcess('vob2jpg', 'Flow2 replacemainthumb', { clipid: clipId, parameters: params }).then(res => {
            console.log(res);
            dispatch(actions.getClipById(clipId));
            let interval = setInterval(function () {
                window.flow.getProcess(res.processid).then(p => {
                    console.log(p);
                    console.log(p.getStatus());
                    if (p.getStatus() == 'done') {
                        clearInterval(interval);
                        dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_SUCCESS });
                    } else if (p.getStatus() == 'error') {
                        clearInterval(interval);
                        dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_FAIL });
                    }
                })
            }, 2000);
        }).catch(res => {
            console.log(res);
            dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_FAIL });
        });
    }
}


export const setRelatedClip = (relatedClip, currentClips) => {
    return {
        type: actionTypes.SET_RELATED_CLIP,
        payload: { relatedClip: relatedClip, currentClips: currentClips }
    }
}

export const resetRelatedClip = () => {
    return {
        type: actionTypes.SET_RELATED_CLIP,
        payload: { relatedClip: null, currentClips: [] }
    }
}
